import {
  GET_PREVIOUS_RESALE_ENQUIRY_MFA,
  GET_PREVIOUS_RESALE_ENQUIRY_NON_MFA,
  GET_RESALE_ITEM_DETAILS_DATA_MFA,
  GET_RESALE_ITEM_DETAILS_DATA_NON_MFA,
  GET_RESALE_LIST_DATA_MFA,
  GET_RESALE_LIST_DATA_NON_MFA,
  SET_RESALE_ASSET_DETAILS_LOADING,
  SET_RESALE_ITEM_DETAILS_DATA,
  SUBMIT_MFA_RESALE_ENQUIRY,
  SUBMIT_NON_MFA_RESALE_ENQUIRY,
} from './resale.actionTypes';

export const loadDataForResaleTractorMFA = (stateName) => {
  return {
    type: GET_RESALE_LIST_DATA_MFA,
    stateName,
  };
};

export const loadDataForResaleTractorNonMFA = (stateName) => {
  return {
    type: GET_RESALE_LIST_DATA_NON_MFA,
    stateName,
  };
};

export const getAssetDetailsByIdForNonMfa = (assetId) => {
  return {
    type: GET_RESALE_ITEM_DETAILS_DATA_NON_MFA,
    assetId,
  };
};

export const getAssetDetailsByIdForMfa = (assetId) => {
  return {
    type: GET_RESALE_ITEM_DETAILS_DATA_MFA,
    assetId,
  };
};

export const setAssetDetailsById = (data) => {
  return {
    type: SET_RESALE_ITEM_DETAILS_DATA,
    data,
  };
};

export const setResaleAssetDetailsLoading = (data) => {
  return {
    type: SET_RESALE_ASSET_DETAILS_LOADING,
    data,
  };
};

export const submitMfaResaleAssetEnquiry = (assetId) => {
  return {
    type: SUBMIT_MFA_RESALE_ENQUIRY,
    assetId,
  };
};

export const submitNonMfaResaleAssetEnquiry = (enquiryData) => {
  return {
    type: SUBMIT_NON_MFA_RESALE_ENQUIRY,
    enquiryData,
  };
};

export const getPreviousResaleEnquiryNonMfa = (data) => {
  return {
    type: GET_PREVIOUS_RESALE_ENQUIRY_NON_MFA,
    data,
  };
};

export const getPreviousResaleEnquiryMfa = (data) => {
  return {
    type: GET_PREVIOUS_RESALE_ENQUIRY_MFA,
    data,
  };
};
